import { localisedValue } from "utils"

/** One lookup table: id / string(id) → { locCode?, title? } */
const buildCountriesById = response =>
  (response ?? []).reduce((acc, e) => {
    if (e?.id == null) return acc
    const title = localisedValue({ object: e, key: "name" })
    const locCode = e?.locCode
    if (!title && locCode == null) return acc
    const entry = { title: title || undefined, locCode: locCode ?? undefined }
    acc[e.id] = entry
    acc[String(e.id)] = entry
    return acc
  }, {})

const countryTransformer = (response, arg) => {
  const nationalityFlag = typeof arg === "boolean" ? arg : arg?.nationalityFlag
  const includeCountriesById = typeof arg === "object" && arg?.includeIdLocCodeById

  if (!response) {
    if (nationalityFlag) {
      return includeCountriesById
        ? { countries: [], nationalities: [], countriesById: {} }
        : { countries: [], nationalities: [] }
    }
    return includeCountriesById ? { countries: [], countriesById: {} } : []
  }

  const countriesById = includeCountriesById ? buildCountriesById(response) : null

  const countries = response.map(e => ({
    ...e,
    key: e?.id,
    label: localisedValue({ object: e, key: "name" }),
    value: e?.id?.toString(),
  }))

  if (nationalityFlag) {
    const nationalities = response.map(e => ({
      ...e,
      label: localisedValue({ object: e, key: "nationalityTitle" }),
      value: e?.id,
    }))

    return {
      countries,
      nationalities,
      ...(includeCountriesById ? { countriesById } : {}),
    }
  }

  if (includeCountriesById) {
    return { countries, countriesById }
  }

  return countries
}

export default countryTransformer
